module.exports = __webpack_public_path__ + "img/Қарағанды облысы.cdd111f9.png";